import Like from './Like';

export default Like;